import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElText,
  genElDate,
} from "../../components/utils/EditorDialogElementGenerator";

import { Divider } from "@mui/material";

let editTitle = "";
const addTitle = "Tambah Kendaraan";

const ChangeDateEditorDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
    jenis_tanggal,
  } = props;

  // dialog state

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */

  if (jenis_tanggal === "tanggal_stnk") {
    editTitle = "STNK";
  } else if (jenis_tanggal === "tanggal_pajak") {
    editTitle = "Pajak";
  } else if (jenis_tanggal === "tanggal_speksi") {
    editTitle = "Speksi";
  }

  const validate = () => {
    let valid = true;
    let newEror = {};

    if (!valid) setError(newEror);

    return valid;
  };

  // handle UI event section

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elNopol = genElText({
    field: "nomor_polisi",
    name: "Nomor Polisi",
    data,
    setData,
    error,
    disabled: true,
  });

  const elJenisMobil = genElText({
    field: "jenis_mobil",
    name: "Jenis Mobil",
    data,
    setData,
    error,
    disabled: true,
  });

  const elTanggalSTNK = genElDate({
    field: jenis_tanggal,
    name: "Tanggal " + editTitle,
    primeFormat: "dd MM yy",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "28rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : "Edit Tanggal " + editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <div className="col-start-center relative h-100">
        <div className="col-start-start w-80 gap-3">
          {elNopol}
          {elJenisMobil}
        </div>
        <br />
        <Divider layout="horizontal" className="w-[25rem]" />
        <br />
        <div className="col-start-start w-80 gap-3">{elTanggalSTNK}</div>

        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-80 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ChangeDateEditorDialog;
